import * as login from "./login";
import * as messageCategory from "./messageCategory";
import * as messageChannel from "./messageChannel";
import * as messageEvent from "./messageEvent";
import * as messageMaster from "./messageMaster";
import * as messageNamespace from "./messageNamespace";
import * as messageNoticeUser from "./messageNoticeUser";
import * as messageUser from "./messageUser";
import * as messageWebSocket from "./messageWebSocket";

export const mns = {
  login,
  messageCategory,
  messageChannel,
  messageEvent,
  messageMaster,
  messageNamespace,
  messageNoticeUser,
  messageUser,
  messageWebSocket,
};
